import { render, staticRenderFns } from "./TaskDetailPage.vue?vue&type=template&id=fee1b7b8&lang=pug&"
import script from "./TaskDetailPage.vue?vue&type=script&lang=js&"
export * from "./TaskDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports